import styled from 'styled-components'
import { PrimaryButton } from '../shared/Buttons/Buttons.styles'

// Forms, inputs
export const FormWrapper = styled.form`
  font-size: 1.6rem;
  max-width: 75rem;
  margin: 0 auto;
  margin-bottom: 6.4rem;
  padding: 0 2rem;

  div {
    margin-bottom: 2.4rem;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      margin-bottom: 4.8rem;
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    margin-bottom: 12rem;
  }
`

export const Label = styled.label`
  display: block;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${props => props.theme.colors.black};
`

export const Dropdown = styled.div`
  position: relative;
  width: 100%;

  select {
    appearance: none;
    width: 100%;
    font-size: 1.6rem;
    font-weight: bold;
    font-family: ${props => props.theme.fonts.bold};
    display: block;
    border: none;
    box-shadow: none;
    border-radius: 0;
    border-bottom: 2px solid ${props => props.theme.colors.imageBorder};
    padding: 1.2rem 0;
    background: transparent;
  }

  option {
    font-weight: 600;
  }

  svg {
    width: 14px;
    height: 14px;
    position: absolute;
    right: 1rem;
    top: 2rem;
    pointer-events: none;
  }
`

export const Input = styled.input`
  display: block;
  width: 100%;
  background: transparent;
  border-bottom: 2px solid ${props => props.theme.colors.imageBorder};
  line-height: 1.75;
  padding: 0.5rem 0;

  &:placeholder {
    font-weight: 300;
  }
`

export const TextArea = styled.textarea`
  background: ${props => props.theme.colors.inputBG};
  width: 100%;
  font-size: 1.6rem;
  min-height: 27rem;
  margin-top: 1rem;
  padding: 1rem 1.2rem;
  border: none;
`

export const Submit = styled(PrimaryButton)`
  font-size: 1.6rem;
  margin-top: 5.6rem;

  button {
    width: 100%;
    margin: 0 auto;
    font-size: 1.6rem;
    padding: 1.6rem;
    max-width: none;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      width: 35.7rem;
      margin: 0 auto;
      font-size: 2.4rem;
      padding: 2.5rem 1.6rem;

      svg {
        margin-top: 0.4rem;
      }
    }
  }

  @media screen and (min-width: ${props => props.theme.responsive.small}) {
    font-size: 2.4rem;
    margin-top: 8rem;
  }
`

export const Checkbox = styled.div`
  input[type="checkbox"] {
    opacity: 0;
    position: absolute;
    left: -9999px;

    & + label::after {
      content: none;
    }

    &:checked + label::after {
      content: "";
    }

    &:focus + label::before {
      outline: rgb(59, 153, 252) auto 5px;
    }
  }

  label {
    position: relative;
    display: inline-block;
    padding-left: 4rem;
    font-size: 1.4rem;
    font-weight: 300;

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      padding-left: 6.4rem;
    }

    a {
      color: ${props => props.theme.colors.black};
    }

    &::before,
    &::after {
      position: absolute;
      content: '';
      display: inline-block;
    }

    &::before {
      height: 24px;
      width: 24px;
      border: 1px solid ${props => props.theme.colors.black};
      left: 0;
      top: 0;
    }

    &::after {
      height: 8px;
      width: 16px;
      border-left: 3px solid ${props => props.theme.colors.black};
      border-bottom: 3px solid ${props => props.theme.colors.black};
      transform: rotate(-45deg);
      left: 4px;
      top: 7px;
    }
  }
`

export const ErrorMessage = styled.span`
  position: relative;
  display: block;
  color: ${props => props.theme.colors.red};
  font-size: 1.4rem;
  margin-top: 1.2rem;
  line-height: 1;
  padding-left: 1.3rem;

  &::before {
    position: absolute;
    content: '!';
    color: ${props => props.theme.colors.red};
    font-size: 2rem;
    font-weight: bold;
    font-family: ${props => props.theme.fonts.bold};
    left: 0;
    top: -0.3rem;
  }
`
